export default {
  Parcel: {id: 1, name: 'shippingMethod.parcel'},
  Freight: {id: 2, name: 'shippingMethod.freight'}
}
